/**
 * Binom Standard Config Tab — drawer-side entry point. Renders the same
 * 2-pane layout we use for Voluum. The shared BinomDrawerProvider is hoisted
 * up to FlowOptimizerDrawerTabs so the Campaign / Advanced peer tabs can
 * also read the draft.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { BinomStandardConfigTabImpl } from './standard/binom';

export interface BinomStandardConfigTabProps {
  killSwitch: boolean;
}

const BinomStandardConfigTab: FC<BinomStandardConfigTabProps> = ({ killSwitch }) => (
  <BinomStandardConfigTabImpl killSwitch={killSwitch} />
);

export default BinomStandardConfigTab;
